import "./styles.css";
import { useContext } from "react";
import TicketObsList from "./pages/TicketObsList";
import TicketsPrintList from "./pages/TicketsPrintList";
import TicketDetails from "./pages/TicketDetails";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import NewTicket from "./pages/NewTicket";
import { GlobalContext } from "./context/GlobalContext";
import Nav from "./components/Nav";
import TimerConfig from "./pages/TimerConfig";
import NotasVenta from "./pages/NotasVenta";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AuthLayout from "./components/auth/AuthLayout";
import { allowedUsers } from "./config/allowedUsers";

const queryClient = new QueryClient();

export default function App() {
  const { context } = useContext(GlobalContext);
  return (
    <ProtectedRoute allowedUsers={allowedUsers}>
      <AuthLayout>
        <div className="App">
          <QueryClientProvider client={queryClient}>
            <Nav />
            {context.page === undefined && <h1>{context}</h1>}
            {context.page === "listObs" && <TicketObsList />}
            {context.page === "listPrint" && <TicketsPrintList />}
            {context.page === "details" && <TicketDetails />}
            {context.page === "newTicket" && <NewTicket />}
            {context.page === "timerConfig" && <TimerConfig />}
            {context.page === "notasVenta" && <NotasVenta />}
          </QueryClientProvider>
        </div>
      </AuthLayout>
    </ProtectedRoute>
  );
}
